var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section-related',{attrs:{"title":"Migration Destinations: ","items":_vm.places,"prerender-list-name":"migration_places","is-template":_vm.isTemplate},scopedSlots:_vm._u([{key:"item",fn:function(ref){
var item = ref.item;
return _c('router-link',{attrs:{"rel":"nofollow","to":_vm.getToRoute(item)}},[_vm._v(" "+_vm._s(item.pinyin))])}}])})}
var staticRenderFns = []

export { render, staticRenderFns }